import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["color", "gradientStops"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { memo, useEffect, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import Icon from './Icon';
var IconGradient = /*#__PURE__*/memo(function (_ref) {
  var color = _ref.color,
    gradientStops = _ref.gradientStops,
    props = _objectWithoutProperties(_ref, _excluded);
  var spanRef = useRef();
  var gradientId = uuidv4();
  useEffect(function () {
    if (!spanRef.current) return;
    var defs = spanRef.current.querySelector('svg defs');
    if (!defs) {
      defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
      spanRef.current.querySelector('svg').appendChild(defs);
    }
    var gradient = document.createElementNS('http://www.w3.org/2000/svg', 'linearGradient');
    gradient.setAttribute('id', gradientId);
    gradientStops.forEach(function (stop) {
      var newStop = document.createElementNS('http://www.w3.org/2000/svg', 'stop');
      newStop.setAttribute('offset', stop.offset);
      newStop.setAttribute('stop-color', stop.color);
      gradient.appendChild(newStop);
    });
    defs.appendChild(gradient);
  }, [gradientId, gradientStops]);
  var iconProps = useMemo(function () {
    return _objectSpread({
      ref: spanRef,
      color: "url(#".concat(gradientId, ")")
    }, props);
  }, [gradientId, props]);
  return /*#__PURE__*/React.createElement(Icon, iconProps);
});
IconGradient.defaultProps = {
  size: 'medium',
  overrides: {},
  gradientStops: [{
    offset: '0%',
    color: '#FF3B30'
  },
  // Red 500
  {
    offset: '100%',
    color: '#FF8C00'
  } // Orange 500
  ]
};

process.env.NODE_ENV !== "production" ? IconGradient.propTypes = {
  className: PropTypes.string,
  overrides: PropTypes.object,
  size: PropTypes.oneOf(['raw', 'small', 'medium', 'large', 'big', 'huge']),
  name: PropTypes.string,
  onClick: PropTypes.func,
  gradientStops: PropTypes.arrayOf(PropTypes.shape({
    offset: PropTypes.string,
    stopColor: PropTypes.string
  }))
} : void 0;
export default IconGradient;